import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import PlanList from "../../Components/PlanList";
import sal from "sal.js";
import { Helmet } from "@dr.pogodin/react-helmet";
import { ScrollToPlans } from "../../utils/ScrollToPlan";
import MinPlanPrice from "../../Components/MinPlanPrice";
import CouponScrollBar from "../../Components/CouponScrollBar";

export default function SSL() {
  const [applyPaddingClass, setApplyPaddingClass] = useState(false);
  useEffect(() => {
    document.title = "SSL Certificate: Boost Trust and Security for Your Website";
          sal();
        }, []);
    const handlePlanClick = () => {
    ScrollToPlans(".price-plan-section");
    };
  return (
    <>
        <Helmet>
            <title>SSL Certificate: Boost Trust and Security for Your Website</title>
            <meta name="description" content="Secure your website and protect user data with a trusted SSL Certificate. Easy installation, instant encryption, and safe browsing guaranteed for every visitor." />
            <meta name="keywords" content="SSL, Buy SSL Certificate, Wildcard SSL, Wildcard Certificate, SSL Certificate Price, Buy SSL, SSL Certificate For Website, SSL Certificate Cost, SSL Certificate" />
            <meta property="og:url" content={`${import.meta.env.VITE_FRONTEND_URL}/ssl-certificate`} />
            <link rel="canonical" href={`${import.meta.env.VITE_FRONTEND_WWW_URL}/ssl-certificate`} />
            <meta property="og:title" content="SSL Certificate - Secure Your Data & Transactions" />
            <meta property="og:description" content="Secure your website and online presence with SSL certificates. Infinitive Host offers you solutions that improve search engine rankings and data security" />
        </Helmet>
        <div className="wordpress-hosting-banner about-banner pb-120 bg-dark">
            <div className="container">
                <div className="row g-4 align-items-center align-items-xxl-end">
                    <div className="col-lg-7">
                        <div className="d-flex align-items-center gap-2">
                            <div className="w-3 h-3 rounded-circle bg-primary flex-shrink-0"></div>
                            <span className="d-block fw-semibold mb-0 text-primary">
                                Top Hosting. Trusted SSL Certificate.
                            </span>
                        </div>
                        <h1 className="mb-6 text-white">
                            Umm… That Tiny SSL Certificate Icon? Show Visitors You’re Legit.
                        </h1>
                        <p className="text-white max-text-60 mb-8 text-opacity-75">
                            Ever clicked a website and thought, “Is this even secure?” Yeah, your site visitors feel the same energy. If your website shows “Not Secure,” then you’re losing trust (& traffic) for sure. With the help of an SSL certificate, your site not only feels secure, but it is safer.
                        </p>
                        <div className="d-flex align-items-center flex-wrap gap-4">
                            <Link to="/contact-us" className="btn btn-primary btn-arrow btn-lg fs-14 fw-semibold rounded btn-height">
                                <span className="btn-arrow__text">
                                    Free Trial
                                    <span className="btn-arrow__icon">
                                        <i className="fa-solid fa-arrow-right"></i>
                                    </span>
                                </span>
                            </Link>
                            <button onClick={handlePlanClick} className="btn btn-light btn-arrow btn-lg fs-14 fw-semibold rounded transition btn-height">
                                <span className="btn-arrow__text">
                                    Explore
                                    <span className="btn-arrow__icon">
                                        <i className="fa-solid fa-arrow-right"></i>
                                    </span>
                                </span>
                            </button>
                            <MinPlanPrice category="ssl" />
                        </div>
                        <span className="d-block fs-14 text-white text-opacity-75 mt-2 sal-animate" data-sal="slide-up" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">Get 100% Refund Within 30 Days* <sup><small className="text-opacity-50 tnc-text">T&Cs</small></sup></span>
                    </div>
                    <div className="col-lg-5 ipad-mt">
                        <div className="about-banner__img">
                            <img src="images/umm-that-tiny-ssl-certificate.webp" alt="image" className="img-fluid full-width-img" />
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <div className="pt-100 pb-100 linux-hosting-points-section">
            <div className="pb-60">
                <div className="container">
                    <div className="row g-4 align-items-center justify-content-xl-between">
                        <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                            <small className="d-inline-block mb-2 fw-bold bg-success-subtle text-success-emphasis border border-success-subtle px-3 py-1 rounded">
                                <span className="d-inline-block w-2 h-2 bg-success rounded-circle me-1"></span>Privacy, By Default. 
                            </small>
                            <h2 className="mb-4">
                                Shh… Still Without an SSL Certificate?
                            </h2>
                            <p className="max-text-56 mb-0 fw-semibold">
                                Site visitors judge in seconds. If your website says “Not Secure,” then they are gone forever. Our SSL certificate always protects and stops them from bouncing, and always keeps them coming back.
                            </p>
                        </div>
                        <div className="col-lg-6 col-xl-5 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                            <div className="card">
                                <div className="card-body cloud-hosting-vid-card">
                                <div className="features-video position-relative z-1">
                                    <img src="/images/infi-common-video-yt-thumb.jpg" alt="image" className="img-fluid w-100"/>
                                    <Link to="https://youtu.be/x10KM9gI110?si=kVgGnbSAsh-zfKn7" target="_blank" className="btn gradient-bg w-15 h-15 d-grid place-content-center rounded-circle position-absolute top-50 start-50 translate-middle fs-24 text-white popup-init">
                                        <i className="fa-solid fa-play"></i>
                                    </Link>
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container">
                <div className="row g-4">
                    <div className="col-md-6 col-lg-4 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        <div className="card border-0 shadow-sm rounded-4 h-100">
                            <div className="card-body p-md-6 p-xl-8">
                                <div className="mb-8">
                                    <img src="/images/trust-more.webp" alt="image" className="img-fluid"/>
                                </div>
                                <h6 className="mb-4">
                                    Trust More. Earn More.
                                </h6>
                                <p className="mb-0">
                                    An SSL certificate gain visitors' trust instantly and always keep your user’s data protected, so you can focus more on increasing revenue.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-4 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                        <div className="card border-0 shadow-sm rounded-4 h-100">
                            <div className="card-body p-md-6 p-xl-8">
                                <div className="mb-8">
                                    <img src="/images/encrypted-&-secure.webp" alt="image" className="img-fluid"/>
                                </div>
                                <h6 className="mb-4">
                                    Encrypted & Secure
                                </h6>
                                <p className="mb-0">
                                    With the help of our SSL certificate, all your sensitive data stays fully encrypted and hidden from any type of unwanted access.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-4 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="500" data-sal-easing="ease-in-out-sine">
                        <div className="card border-0 shadow-sm rounded-4 h-100">
                            <div className="card-body p-md-6 p-xl-8">
                                <div className="mb-8">
                                    <img src="/images/lock-a-trust-badge.webp" alt="image" className="img-fluid"/>
                                </div>
                                <h6 className="mb-4">
                                    Lock? A Trust Badge
                                </h6>
                                <p className="mb-0">
                                    The green lock and HTTPS tell all visitors that your website is protected-no matter the language, their data stays secure always.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-4 sal-animate" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        <div className="card border-0 shadow-sm rounded-4 h-100">
                            <div className="card-body p-md-6 p-xl-8">
                                <div className="mb-8">
                                    <img src="/images/google-loves-ssl.webp" alt="image" className="img-fluid"/>
                                </div>
                                <h6 className="mb-4">
                                    Google Loves SSL
                                </h6>
                                <p className="mb-0">
                                    Not showing up where you should? Just because of the missing green lock. Buy SSL & give your site the boost Google loves.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-4 sal-animate" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                        <div className="card border-0 shadow-sm rounded-4 h-100">
                            <div className="card-body p-md-6 p-xl-8">
                                <div className="mb-8">
                                    <img src="/images/privacy-begins-with.webp" alt="image" className="img-fluid"/>
                                </div>
                                <h6 className="mb-4">
                                    Privacy Begins with SSL
                                </h6>
                                <p className="mb-0">
                                    Get an SSL certificate to safeguard your website visitors’ information. Only they and you can see it anytime. No one else gets in.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-4 sal-animate" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="500" data-sal-easing="ease-in-out-sine">
                        <div className="card border-0 shadow-sm rounded-4 h-100">
                            <div className="card-body p-md-6 p-xl-8">
                                <div className="mb-8">
                                    <img src="/images/ssl-made.webp" alt="image" className="img-fluid"/>
                                </div>
                                <h6 className="mb-4">
                                    SSL Made Affordable
                                </h6>
                                <p className="mb-0">
                                    Free SSL is quite cool, but unbeatable security starts with our paid SSL. Get smart security at budget-friendly price with Infinitive Host.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <section className="price-plan-section pt-100 pb-100">
            <CouponScrollBar setPaddingClass={setApplyPaddingClass} />
            <div className={`pb-40 ${applyPaddingClass ? "plan-extra-top-padding" : ""}`}>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-xl-8">
                            <div className="text-center">
                                <span className="section-title-dark style-bg fadeInUp">Our Plans</span>
                                <h2 className="theme-title-text-white" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine"> Scalable Plans for Every Mood of Yours</h2>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <PlanList category={'ssl'}/>
        </section>

        <section className="pt-60 pb-100">
            <div className="container">
                <div className="cta-wrapper-one pt-60 pb-60 px-6 rounded-3">
                    <div className="row justify-content-center">
                        <div className="col-xxl-7 col-xl-9">
                            <div className="d-flex justify-content-center sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine">
                                <div className="px-3 py-1 border border-primary rounded d-inline-flex align-items-center gap-2">
                                    <div className="w-2 h-2 rounded-circle bg-primary"></div>
                                    <small className="text-primary fw-bold">Every Click Deserves Protection.</small>
                                </div>
                            </div>
                            <div className="text-center mt-5">
                                <h2 className="mb-5 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine">Secure Your Website With an SSL Certificate With Us</h2>
                                <p className="mb-8 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine">Security meets visibility-safeguard your site visitors and rise in search with the help of Infinitive Host’s SSL certificate. </p>
                            </div>
                            <div className="d-flex align-items-center justify-content-center gap-4 flex-wrap flex-md-nowrap sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine">
                                <button onClick={handlePlanClick} className="btn btn-primary btn-arrow btn-arrow-md btn-lg fs-14 fw-medium rounded btn-height">
                                    <span className="btn-arrow__text">
                                        Start Now
                                        <span className="btn-arrow__icon">
                                            <i className="fa-solid fa-arrow-right"></i>
                                        </span>
                                    </span>
                                </button>
                                <Link to="/frequently-asked-questions" className="btn btn-dark btn-arrow btn-arrow-md btn-lg fs-14 fw-medium rounded btn-height">
                                    <span className="btn-arrow__text">
                                        Learn More
                                        <span className="btn-arrow__icon">
                                            <i className="fa-solid fa-arrow-right"></i>
                                        </span>
                                    </span>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </>
  );
}
